import React from 'react';

import ErrorPage from './ErrorPage';
import MainLayout from './main/MainLayout';

function MaintenancePage() {
  return (
    <MainLayout>
      <ErrorPage
        title="We'll be back soon"
        text="We're sorry for the inconvenience but we are performing maintenance. Please check back soon..."
      />
    </MainLayout>
  );
}

export default MaintenancePage;
